import { Component } from '@angular/core';

@Component({
	selector: 'lib-divider',
	imports: [],
	standalone: true,
	templateUrl: './divider.component.html',
	styleUrl: './divider.component.css',
})
export class DividerComponent {}
